<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/sw5j0L/images/cover.jpg?1739570926993" alt="This image is the cover for the book Other Groom"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Other Groom
      </h1>
      <p class="bookDescription body article font2">
        <b>Someone Wanted Her Dead</b><br/><br/>or so her faintly familiar bodyguard kept telling her. But the only person “Louisa Haversham Winslow” needed protection from was <i>him</i>because this gentle giant of a man made her crave things no respectable newly widowed woman should desire!<br/><br/>Neil Ballard knew every minute Phoebe Gray spent as the counterfeit Widow Winslow was perilous. Yet he would guard his childhood friend with his life, for surely she was meant to be his everlasting love! The sensuous pull between him and his runaway bride couldn’t lie. The truth must emergebut how? Through the deadly danger that stalked heror the passion that consumed them both?
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lisa Bingham
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?add6047e